/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Editor_SubtitleInputs */

const vi_packaging_editor_subtitle = /** @type {(inputs: Packaging_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự động gợi ý theo định mức. Có thể sửa số lượng, xóa, hoặc thêm vật tư khác.`)
};

/**

* @param {Packaging_Editor_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_editor_subtitle = /** @type {((inputs?: Packaging_Editor_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Editor_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_editor_subtitle(inputs)
});